import React, { Component } from 'react';
import Popup from "reactjs-popup";
import { connect } from 'react-redux';
import axios from 'axios'
import { geolocated } from "react-geolocated";
import SetAdvertiseLocation from './SetAdvertiseLocation';
import Loader from './utility/Loader';
import { notifyUser, type } from './utility/notifyUser';
import adService from './advertisements/service/adService';
import authservice from './Authentication/service/authservice';

class LocationPopUpGuest extends Component {

    constructor(props) {
        super(props);
        this.addressOptions = [];
        this.selectedNeighbourhood = [];
        this.selectedLocality = [];
        this.selectedCity = [];
        this.selectedState = [];
        this.stateValidation = null;
        this.cityValidation = null;
        this.localityValidation = null;
        this.neighbourhoodValidation = null;
    }
    state = {
        open: true,
        closeButton: false,
        selectedNeighbourhood: [],
        selectedLocality: [],
        selectedCity: [],
        selectedState: [],
        fullAddress: [],
        errors: {
            address: '',
            email_address: '',
            contact_person: '',
            contact_number: '',
            website: '',
            invalidTime: '',
            thumbnailImageSizeError: '',
            address_info: '',
        },
        showPopup: false,
        hasGetStateBeenCalled: false
    };

    componentDidUpdate() {
        this.props.sendData([])
        if(this.props.open && !this.hasGetStateBeenCalled) {
            this.getState()
            this.hasGetStateBeenCalled = true;
        }
    }

    componentDidMount() {
        this.props.notifyPopupOpen(true)
    }

    getState = () => {
        Promise.all([
            axios.get(process.env.REACT_APP_BACKEND_URL + '/hpmgr/listing/getallstates'),
        ]).then(([getFullAddress]) => { // use arrow function to avoid loosing context, BTW you don't need to use axios.spread with ES2015 destructuring
            this.setState({ fullAddress: getFullAddress.data });
            this.props.fullAddress(getFullAddress.data)
            Loader.stopSpinner()
        }).catch(error => {
            Loader.stopSpinner()
            console.log(error, 'getting data failed');
        });
    }

    _handleState = (selectedStates) => {
        if (selectedStates.length)
            this.selectedState = selectedStates;
        else
            this.selectedState = [];
    }

    _handleCity = (e) => {
        if (e.length)
            this.selectedCity = e;
        else
            this.selectedCity = [];
    }
    _handleLocality = (e) => {
        if (e.length)
            this.selectedLocality = e;
        else
            this.selectedLocality = [];
    }
    _handleNeighbourhood = (e) => {
        if (e.length)
            this.selectedNeighbourhood = e
        else
            this.selectedNeighbourhood = [];
    }

    setAddressOptions = (options) => {
        this.addressOptions = options
    }

    setStateValidationMethod = (m) => {
        this.stateValidation = m;
    }

    setCityValidationMethod = (m) => {
        this.cityValidation = m;
    }

    setLocalityValidationMethod = (m) => {
        this.localityValidation = m;
    }

    setNeighbourhoodValidationMethod = (m) => {
        this.neighbourhoodValidation = m;
    }

    closeModal = () => {
        this.props.closeModal();
    }

    searchDataHandler = event => {
        event.preventDefault();

        let states = []
        this.selectedState.map(data => {
            states.push(data.label)
        })
        localStorage.setItem('state', states)
        let cities = []
        this.selectedCity.map(data => {
            cities.push(data.label)
        })
        localStorage.setItem('city', cities)
        let localities = []
        this.selectedLocality.map(data => {
            localities.push(data.label)
        })
        localStorage.setItem('locality', localities)
        let neighbourhoods = []
        this.selectedNeighbourhood.map(data => {
            neighbourhoods.push(data.label)
        })
        localStorage.setItem('neighbourhood', neighbourhoods)
        if (this.selectedState.length < 1) {
            this.setState({ open: true })
            notifyUser("Location", "Select Any State", type.DANGER)
        }
        else if (this.cityValidation) {
            if (this.selectedCity.length < 1) {
                this.setState({ open: true })
                notifyUser("Location", "Select Any City", type.DANGER)
            }
            else if (this.localityValidation) {
                if (this.selectedLocality.length < 1) {
                    this.setState({ open: true })
                    notifyUser("Location", "Select Any Locality", type.DANGER)
                }
                else if (this.neighbourhoodValidation) {
                    if (this.selectedNeighbourhood.length < 1) {
                        this.setState({ open: true })
                        notifyUser("Location", "Select Any Neighbourhood", type.DANGER)
                    }
                    else {
                        this.setState({ open: false })
                        localStorage.getItem('neighbourhood', neighbourhoods)
                        this.closeModal()
                        notifyUser("Location", "Your Location has been updated", type.INFO)
                    }
                }
                else {
                    this.setState({ open: false })
                    localStorage.getItem('locality', localities)
                    this.closeModal()
                    notifyUser("Location", "Your Location has been updated", type.INFO)
                }
            }
            else {
                this.setState({ open: false })
                localStorage.getItem('city', cities)
                this.closeModal()
                notifyUser("Location", "Your Location has been updated", type.INFO)
            }
        }
        else {
            this.setState({ open: false })
            localStorage.getItem('state', states)
            this.closeModal()
            notifyUser("Location", "Your Location has been updated", type.INFO)
        }

        const data = {
            category: null,
            subCategory: null,
            state: states,
            city: cities,
            locality: localities,
            neighbourhood: neighbourhoods,
            ...this.props.current_coords,
            distance: this.state.radius,
            offset: 0,
            num_rows: 10,
            businessPackage: null,
            keyword: '',
        }

        this.setState({ activeMenu: '', showMenu: false })

        if (parseInt(this.state.radius) || states.length || cities.length || localities.length || neighbourhoods.length) {
            if (parseInt(this.state.radius) && !states.length) {
                return !data.latitude ? (
                    notifyUser("Geolocation", "Geolocation is not enabled...!", type.WARNING)
                ) : {
                    searchRequest: data,
                    searchCriteria: "searching",
                }
            }
            // else {
            //     this.props.history.push('/search', {
            //         searchRequest: data,
            //         searchCriteria: "searching",
            //     })
            // }

            const searchLocation = {
                state: localStorage.getItem('state', states),
                city: localStorage.getItem('city', cities),
                locality: localStorage.getItem('locality', localities),
                neighbourhood: localStorage.getItem('neighbourhood', neighbourhoods),
                guestId: authservice.getCookie('hp.rocks.soon'),
                userId: authservice.getCurrentUserid(),
            }
            return axios.post(process.env.REACT_APP_BACKEND_URL + `/abmgr/auth/save-visitor-location`, searchLocation)
                .then(response => {
                    window.location.reload()
                    return response.data
                }).then(null, error => {
                    console.log("Error : " + error)
                    return [];
                });
        }
    }

    render() {

        return (
            <>
                <div className='locateDesktopPopup'>
                    <Popup
                        open={this.props.open}
                        closeOnDocumentClick={false}
                        closeOnEscape={false}
                        onClose={this.closeModal}
                        lockScroll={true}
                        overlayStyle={{ background: 'rgba(0,0,0,0.95)' }}
                        contentStyle={{ width: "336px", color: 'black' }}
                    >
                        <div className='row col-md-12'>
                            <form onSubmit={this.searchDataHandler}>
                                <div className="text-center location_margin">
                                    <h2>Searching for Anything?</h2>
                                    <h2>Tell us your location...</h2>
                                    <h2>To see what's near you</h2>

                                    <SetAdvertiseLocation
                                        //heading='Areas Served' isMulti
                                        setFilterValidationMethod={this.setLocationValidationMethod}
                                        allLocations={this.state.fullAddress}
                                        selectedStates={this.state.selectedState}
                                        selectedCities={this.state.selectedCity}
                                        selectedLocalities={this.state.selectedLocality}
                                        selectedNeighbourhoods={this.state.selectedNeighbourhood}
                                        _handleState={this._handleState}
                                        _handleCity={this._handleCity}
                                        _handleLocality={this._handleLocality}
                                        _handleNeighbourhood={this._handleNeighbourhood}
                                        addressOptions
                                        setAddressOptions={this.setAddressOptions}
                                        labelClass={'col-md-2'}
                                        setStateValidationMethod={this.setStateValidationMethod}
                                        setCityValidationMethod={this.setCityValidationMethod}
                                        setLocalityValidationMethod={this.setLocalityValidationMethod}
                                        setNeighbourhoodValidationMethod={this.setNeighbourhoodValidationMethod}
                                    />
                                </div>
                                <p className='location_p'>(If your location is not available, Please select your nearest location.)</p>

                                <div className="col-md">
                                    <div className="col search_button_col text-center location_padding">
                                        <button className='btn btn-warning lookup_button location_btn' type="submit" onClick={this.searchDataHandler}>Set My Location</button>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </Popup>
                </div>
                <div className='locateMobilePopup'>
                    <Popup
                        open={this.props.open}
                        closeOnDocumentClick={false}
                        closeOnEscape={false}
                        onClose={this.closeModal}
                        lockScroll={true}
                        overlayStyle={{ background: 'rgba(0,0,0,0.95)' }}
                        contentStyle={{ width: "336px", color: 'black', bottom: '32%' }}
                    >
                        <div className='row col-md-12'>
                            <form onSubmit={this.searchDataHandler}>
                                <div className="text-center location_margin">
                                    <h2>Searching for Anything?</h2>
                                    <h2>Tell us your location...</h2>
                                    <h2>To see what's near you</h2>

                                    <SetAdvertiseLocation
                                        //heading='Areas Served' isMulti
                                        setFilterValidationMethod={this.setLocationValidationMethod}
                                        allLocations={this.state.fullAddress}
                                        selectedStates={this.state.selectedState}
                                        selectedCities={this.state.selectedCity}
                                        selectedLocalities={this.state.selectedLocality}
                                        selectedNeighbourhoods={this.state.selectedNeighbourhood}
                                        _handleState={this._handleState}
                                        _handleCity={this._handleCity}
                                        _handleLocality={this._handleLocality}
                                        _handleNeighbourhood={this._handleNeighbourhood}
                                        addressOptions
                                        setAddressOptions={this.setAddressOptions}
                                        labelClass={'col-md-2'}
                                        setStateValidationMethod={this.setStateValidationMethod}
                                        setCityValidationMethod={this.setCityValidationMethod}
                                        setLocalityValidationMethod={this.setLocalityValidationMethod}
                                        setNeighbourhoodValidationMethod={this.setNeighbourhoodValidationMethod}
                                    />
                                </div>
                                <p className='location_p'>(If your location is not available, Please select your nearest location.)</p>

                                <div className="col-md">
                                    <div className="col search_button_col text-center location_padding">
                                        <button className='btn btn-warning lookup_button location_btn' type="submit" onClick={this.searchDataHandler}>Set My Location</button>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </Popup>
                </div>
            </>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        //sendData: (bodyData) => dispatch({ type: 'SEND_DATA', post_data: bodyData }),
        notifyPopupOpen: (isPopupOpen) => dispatch({ type: 'POPUP_OPEN_NOTIFICATION', isPopupOpen: isPopupOpen }),
        fullAddress: (fulladdress) => dispatch({ type: "full_address", full_address: fulladdress }),
        sendData: (bodyData) => dispatch({ type: 'SEND_DATA', post_data: bodyData }),
        setAddress: (setAdr) => dispatch({ type: "set_address", set_address: setAdr }),
        clearPropsData: () => dispatch({ type: 'CLEAR_DATA' })

    }
}

export default geolocated({
    positionOptions: {
        enableHighAccuracy: false,
    },
    userDecisionTimeout: 5000,
})(connect(null, mapDispatchToProps)(LocationPopUpGuest));